import React from 'react';
import * as Yup from 'yup';
import { Form, Formik } from 'formik';

import {
  ParticipationSource,
  SessionLink,
  useUpdateSessionLink,
} from '@app/api';
import { SubmitButton } from '@app/core';
import { Theme } from '@app/theme';
import { Input, Select, Checkbox } from '@app/form';

import { useFormikSubmit } from '../../../../hooks/useFormikSubmit';
import { createUseStyles } from 'react-jss';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  sameLine: {
    display: 'flex',
    gap: theme.marginBase * 4,
  },
  column: {
    flex: 1,
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));

const settingsValidationSchema = Yup.object().shape({});

interface Props {
  sessionLink: SessionLink;
  onSuccess?: () => any;
}

export const EditSessionLink = ({ sessionLink, onSuccess }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const defaultSources = [
    {
      value: ParticipationSource.LINK,
      label: t('sessions.details.monitoring.sources.LINK'),
    },
    {
      value: ParticipationSource.INVITE,
      label: t('sessions.details.monitoring.sources.INVITE'),
    },
    {
      value: ParticipationSource.ADS,
      label: t('sessions.details.monitoring.sources.ADS'),
    },
    {
      value: ParticipationSource.TANDEMZ_PANEL,
      label: t('sessions.details.monitoring.sources.TANDEMZ_PANEL'),
    },
    {
      value: ParticipationSource.MANUAL_RECRUIT,
      label: t('sessions.details.monitoring.sources.MANUAL_RECRUIT'),
    },
    {
      value: ParticipationSource.REFERRAL,
      label: t('sessions.details.monitoring.sources.REFERRAL'),
    },
    {
      value: ParticipationSource.PARTNER,
      label: t('sessions.details.monitoring.sources.PARTNER'),
    },
  ];

  const { mutateAsync: updateSessionLink } = useUpdateSessionLink(
    sessionLink.id,
  );

  const [initialValues, submit] = useFormikSubmit(
    updateSessionLink,
    sessionLink,
    undefined,
    { onSuccess },
  );

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={submit}
      validationSchema={settingsValidationSchema}
    >
      <Form>
        <Checkbox
          name="recruitmentByTandemz"
          label={t('editSession.admin.sessionLink.byTandemz')}
        />
        <div className={classes.sameLine}>
          <Select
            name="defaultSource"
            options={defaultSources}
            label={t('editSession.admin.sessionLink.defaultSource')}
          />
          <Input
            name="defaultSourceDetails"
            label={t('editSession.admin.sessionLink.defaultSourceDetails')}
          />
        </div>
        <div className={classes.buttonContainer}>
          <SubmitButton small text={t('editSession.admin.sessionLink.save')} />
        </div>
      </Form>
    </Formik>
  );
};
